var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.997.343 2.448 4.894a.66.66 0 0 0 .495.372l5.507.772a.646.646 0 0 1 .526.435.619.619 0 0 1-.177.653l-3.962 3.806a.658.658 0 0 0-.204.572l.932 5.38a.62.62 0 0 1-.242.637.648.648 0 0 1-.69.05l-4.924-2.547a.77.77 0 0 0-.612 0L5.2 17.914a.68.68 0 0 1-.693-.057.661.661 0 0 1-.268-.63l.932-5.38a.703.703 0 0 0-.175-.572L1.004 7.469a.627.627 0 0 1-.17-.664.63.63 0 0 1 .211-.292.647.647 0 0 1 .338-.132L6.86 5.61a.676.676 0 0 0 .495-.372L9.803.343a.693.693 0 0 1 .597-.33.71.71 0 0 1 .597.33Z",
    fill: "#FBCD29"
  })));
};

export default SvgStar;